module.exports = __webpack_public_path__ + "static/img/moreFunction6.2cebd0a.webp";


//////////////////
// WEBPACK FOOTER
// ./static/images2/moreFunction6.webp
// module id = 9oD7
// module chunks = 2